module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lwhTU"))).then(() => parcelRequire('hEqeo'));